<template>
    <div class="user-center">
        <div class="top-block">
            <UploadAvatar></UploadAvatar>
            <div class="name">
                <div class="name-title">
                    <span v-show="!showIpt">
                        {{ info.name }}
                    </span>
                    <a-input ref="titleInput" v-model:value="info.name" v-show="showIpt" class="title-input"
                        @pressEnter="save" @blur="save" width="120" :maxlength="8"></a-input>
                    <svg class="iconpark-icon edit" @click="toggleInput">
                        <use href="#bianji-9m2dm6m0"></use>
                    </svg>
                </div>
                <div class="name-value">{{ info.company_name }}</div>
            </div>
        </div>
        <div class="middle-block">
            <div class="info">个人账号信息</div>
            <div class="phone">
                <span class="name">登录手机</span>
                <span class="value">{{ info.mobile }}</span>
                <svg class="iconpark-icon edit" @click="toggleInfo('phone')">
                    <use href="#bianji-9m2dm6m0"></use>
                </svg>
            </div>
            <!-- <div class="email">
                <span class="name">登录邮箱</span>
                <span class="value" :title="info.email">{{ info.email }}</span>
                <svg class="iconpark-icon edit" @click="toggleInfo('email')">
                    <use href="#bianji-9m2dm6m0"></use>
                </svg>
            </div> -->
        </div>
        <div class="bottom-block">
            <!-- <span class="password item" @click="showPsdModal(true)"
                ><svg class="iconpark-icon"><use href="#ickey"></use></svg>修改密码</span
            > -->
            <span class="logout item" @click="handleLogout"><svg class="iconpark-icon">
                    <use href="#icexit"></use>
                </svg>退出登录</span>
        </div>
    </div>
    <PhoneModal v-if="modalType == 'phone'" v-model="visibleModal"></PhoneModal>
    <InfoEditModal :modalType="modalType" v-model="visibleModal" :editData="editData" @refreshList="refreshList" v-else>
    </InfoEditModal>
    <Modal v-model:visible="psdModal" title="修改密码" class="new-style-modal" :maskClosable="false" :footer="null"
        :width="465" :zIndex="99999">
        <PasswordModal v-if="psdModal" @showPsdModal="showPsdModal" />
    </Modal>
</template>

<script lang="ts" setup>
import PasswordModal from './components/change-password/index.vue'
import UploadAvatar from './components/upload-avatar/index.vue'
import InfoEditModal from './components/info-edit-modal/index.vue'
import IconClose from '@/assets/icon/icon-close.svg?component'
import IconEdit from '@/assets/icon/icon-edit.svg?component'

import { Modal } from 'ant-design-vue'
import 'ant-design-vue/es/modal/style/css'

import { useHooks } from './hooks'

const props = defineProps(['modelValue'])
const emit = defineEmits(['hide', 'update:modelValue'])
const {
    showIpt,
    titleInput,
    password,
    info,
    visibleModal,
    modalType,
    editData,
    psdModal,
    save,
    refreshList,
    toggleInput,
    toggleInfo,
    showPsdModal,
    handleClose,
    handleLogout
} = useHooks(emit)
</script>

<style lang="less" scoped>
.iconpark-icon {
    display: inline-block;
    width: 16px;
    height: 16px;
}

.user-center {
    width: 264px;
    padding: 10px 8px;

    .top-block {
        display: flex;
        align-items: center;
        padding-bottom: 16px;
        border-bottom: 1px solid #e8e8e8;

        .name {
            margin-left: 12px;

            .name-title {
                display: flex;
                align-items: center;

                margin-bottom: 4px;

                span {
                    font-size: 16px;
                    font-weight: 500;
                    color: rgba(0, 0, 0, 0.9);
                }

                .edit {
                    display: none;
                    margin-left: 20px;
                }

                &:hover {
                    .edit {
                        display: block;
                    }
                }
            }

            .title-input {
                width: 120px;
            }

            .name-value {
                color: rgba(0, 0, 0, 0.4);
                font-size: 12px;
            }
        }
    }

    .middle-block {
        padding: 16px 0 14px 0;
        border-bottom: 1px solid #e8e8e8;

        .info {
            color: rgba(0, 0, 0, 0.9);
            font-size: 12px;
            margin-bottom: 16px;
        }

        .phone {
            margin-bottom: 8px;
        }

        .phone,
        .email {
            display: flex;
            align-items: center;
        }

        .name {
            color: rgba(0, 0, 0, 0.4);
            font-size: 14px;
            margin-right: 12px;
            white-space: nowrap;
        }

        .value {
            color: rgba(0, 0, 0, 0.9);
            font-size: 14px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            font-weight: 600;
        }

        .email .value {
            width: 150px;
        }

        .phone,
        .email {
            position: relative;

            .edit {
                position: absolute;
                top: 50%;
                right: 0;
                transform: translateY(-50%);
                display: none;
            }

            &:hover {
                .edit {
                    display: block;
                }
            }
        }
    }

    .bottom-block {
        .iconpark-icon {
            margin-right: 4px;
        }

        padding-top: 16px;
        display: flex;
        align-items: center;

        .item {
            display: flex;
            flex: 1;
            align-items: center;
            font-size: 14px;
            justify-content: center;
        }

        .password {
            color: #333333;
            position: relative;

            &::after {
                width: 1px;
                content: '';
                display: block;
                position: absolute;
                right: 0;
                top: -2px;
                bottom: -2px;
                background: #d8d8d8;
            }
        }

        .logout {
            color: #ff3030;
        }
    }
}

.edit,
.password,
.logout {
    cursor: pointer;
}
</style>
